<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-header">
        <h4 qid="administration-users-view-page-title">
          {{ user.name }}
        </h4>
      </div>
      <div class="card-body">
        <div class="content-view-body">
          <div>
            <p class="text-dark">
              {{ $t('administration.users.create.name_label') }}
            </p>
            <hr>
            <p>{{ user.name }}</p>
            <br>
          </div>
          <div>
            <p class="text-dark">
              {{ $t('administration.users.create.email_label') }}
            </p>
            <hr>
            <p>{{ user.email }}</p>
            <br>
          </div>
          <div>
            <p class="text-dark">
              {{ $t('administration.users.create.phone_label') }}
            </p>
            <hr>
            <p>{{ user.phone }}</p>
            <br>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js'

export default {
  name: 'UserView',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('administration.title'),
          to: '/administration'
        },
        {
          text: this.$t('administration.users.title'),
          to: '/administration/users'
        }
      ],
      user: {}
    }
  },
  components: {

  },
  created () {

    let self = this;

    piincHttp.get('users/' + this.$route.params.slug).then(function(response) {
      self.user = response.data;
      // Push clients name in breadcrumb array
      self.breadcrumbItems.push({text: self.user.name, active: true});
    }, function() {

    });
  }
}
</script>
